var _style, _defs, _defs2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "38.15 32.25 61 60.95",
    style: {
      enableBackground: "new 38.15 32.25 61 60.95"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF5350;}\n\t.st1{fill:#212121;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{clip-path:url(#SVGID_3_);fill:#EF5350;}\n\t.st4{clip-path:url(#SVGID_3_);fill:#FFEE58;}\n\t.st5{clip-path:url(#SVGID_5_);}\n\t.st6{clip-path:url(#SVGID_6_);fill:#3949AB;}\n\t.st7{clip-path:url(#SVGID_6_);fill:#FFFFFF;}\n\t.st8{clip-path:url(#SVGID_6_);fill:#EF5350;}\n\t.st9{clip-path:url(#SVGID_8_);}\n\t.st10{clip-path:url(#SVGID_9_);fill:#EF5350;}\n\t.st11{clip-path:url(#SVGID_9_);fill:#FFFFFF;}\n\t.st12{clip-path:url(#SVGID_9_);fill:#3949AB;}\n\t.st13{clip-path:url(#SVGID_11_);}\n\t.st14{clip-path:url(#SVGID_12_);fill:#EF5350;}\n\t.st15{clip-path:url(#SVGID_12_);fill:#66BB6A;}\n\t.st16{clip-path:url(#SVGID_12_);fill:#FFFFFF;}\n\t.st17{clip-path:url(#SVGID_12_);fill:#212121;}\n\t.st18{clip-path:url(#SVGID_14_);}\n\t.st19{clip-path:url(#SVGID_15_);fill:#FFFFFF;}\n\t.st20{clip-path:url(#SVGID_15_);fill:#66BB6A;}\n\t.st21{clip-path:url(#SVGID_15_);fill:#EF5350;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_10_",
    cx: 68.63,
    cy: 62.73,
    r: 30.39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "UAE_6_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: 24.8,
    y: 25.63,
    width: 127.17,
    height: 74.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.46,
    y: 25.63,
    className: "st3",
    width: 37.08,
    height: 74.2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 61.54,
    y: 25.63,
    style: {
      clipPath: "url(#SVGID_3_)",
      fill: "#66BB6A"
    },
    width: 90.09,
    height: 24.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.54,
    y: 50.36,
    style: {
      clipPath: "url(#SVGID_3_)",
      fill: "#FFFFFF"
    },
    width: 90.09,
    height: 24.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.54,
    y: 75.1,
    style: {
      clipPath: "url(#SVGID_3_)",
      fill: "#212121"
    },
    width: 90.09,
    height: 24.73
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.d4d22c7a3fbd978588b53cc75589980d.svg";
export { ForwardRef as ReactComponent };